import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BreadCrumbModel } from 'app/views/campaign-3/models/campaign-3-breadcrumb.model';

@Component({
  selector: 'app-kv-breadcrumb',
  templateUrl: './kv-breadcrumb.component.html',
  styleUrls: ['./kv-breadcrumb.component.css']
})
export class KvBreadcrumbComponent implements OnInit {

  @Input() arrayBreadcrumbs: Array<BreadCrumbModel> = [];
  @Input() homeRoute: string = "/";
  @Input() homeTooltip: string = "menu.dashboard";

  @Output() onClickBreadcrumb: EventEmitter<BreadCrumbModel> = new EventEmitter<BreadCrumbModel>();

  constructor() { }

  ngOnInit() {}

  onClick(breadcrumb: BreadCrumbModel){
    this.onClickBreadcrumb.emit(breadcrumb);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/kv-breadcrumb/kv-breadcrumb/kv-breadcrumb.component.ts